var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseTemplate',[_c('div',{staticClass:"rewards-coming-soon"},[_c('img',{attrs:{"src":_vm.comingSoonImage,"alt":"Rewards Coming Soon"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }